import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ROUTING_LOGIC_KNOWLEDGE_BASE_URL } from '../constants/RoutingRulesKnowledgeBaseUrls';
import { getAssignByAvailability } from '../utils/getAssignByAvailability';
import { jsx as _jsx } from "react/jsx-runtime";
export const RoutingMethodTooltip = ({
  routingRules
}) => {
  const commonProps = {
    elements: {
      Link
    },
    options: {
      external: true,
      href: ROUTING_LOGIC_KNOWLEDGE_BASE_URL
    }
  };
  if (getAssignByAvailability(routingRules)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.method.leastBusy_jsx"
    }, commonProps));
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
    message: "routing-ui.routingRules.assignment.method.randomly_jsx"
  }, commonProps));
};
RoutingMethodTooltip.displayName = 'RoutingMethodTooltip';